import { TableCell } from "@material-ui/core";
import AttachmentIcon from '@material-ui/icons/Attachment';
import MessageIcon from '@material-ui/icons/MessageOutlined';
import DoneIcon from '@material-ui/icons/Done';
import { Linked, pureRenderProps } from "@type-r/react";
import { OrderModel, ParticipantRoles } from "api";
import { getCustomerName, getSupplierName } from 'api/order';
import { Attachments } from 'common';
import { asDate, asTime, CollapsableSection, Column, Columns, CompactTextArea, FormInput, FormLabel, FormValue, InlineTable, Subsection, TableRow, TopSection } from "lqx-react";
import * as React from "react";
import { Fragment } from "react";

export const AdditionalInfo =
  pureRenderProps({
    supplier: OrderModel.attributes.supplier,
    distributor: OrderModel.attributes.distributor,
    logs: OrderModel.attributes.logs,
    uploads: OrderModel.attributes.uploads,
    conversationId: OrderModel.attributes.conversation_id,
    $note: Linked,
    $comment: Linked,
    $dialog: Linked
  },
    ({ supplier, distributor, logs, uploads, conversationId, $note, $comment, $dialog }) => {
      return (
        <TopSection id="additional-info" title="Additional Information">
          <CollapsableSection id="supplier" title="Supplier" info={supplier.name}>
            <Columns>
              <Column>
                <FormInput label="Vendor" value={supplier.vendor_id} />
                <FormInput label="Currency" value={supplier.currency} />
              </Column>
              <Column>
                <FormInput label="Terms (Days)" value={supplier.terms} />
                <FormInput label="INCO Terms" $value={supplier.$.inco_terms} />
              </Column>
            </Columns>
            <ReadonlyAddress model={supplier} conversationId={conversationId} role={ParticipantRoles.Supplier} />
          </CollapsableSection>

          <CollapsableSection id="customer" title="Customer" info={getCustomerName(conversationId)}>
            <Columns>
              <Column>
                <FormInput label="Customer ID" value={distributor.id} />
              </Column>
              <Column>
              </Column>
            </Columns>
            <ReadonlyAddress model={distributor} conversationId={conversationId} role={ParticipantRoles.Customer} />
          </CollapsableSection>

          <CollapsableSection id="notes" title="Notes">
            <Columns>
              <Column>
                <CompactTextArea label="Notes" rows={5} $value={$note} disabled />
              </Column>
            </Columns>
          </CollapsableSection>

          <CollapsableSection id="comments" title="Comments">
            <Columns>
              <Column>
                <CompactTextArea label="Comments" rows={5} $value={$comment} />
              </Column>
            </Columns>
          </CollapsableSection>

          <Attachments $dialog={$dialog} uploads={uploads} />

          <CollapsableSection id="all-activity" title="All Activity">
            <EventLogs logs={logs} />
          </CollapsableSection>
        </TopSection>
      )
    })

const ReadonlyAddress = ({ model, conversationId, role }) => {
  const attributes = model.attributes;
  const participantRole: ParticipantRoles = role;

  let participantName = '';
  switch (participantRole) {
    case ParticipantRoles.Supplier: {
      participantName = getSupplierName(conversationId);
      break;
    }
    case ParticipantRoles.Customer: {
      participantName = getCustomerName(conversationId);
      break;
    }
    default:
  };


  const { address, contact } = attributes;
  return (
    <Subsection title="Address & Contact Information">
      <Columns>
        <Column>
          <FormInput label="Name" value={participantName} />
          <FormInput label="Email" value={contact.email} />
          <FormInput label="Phone" value={contact.phone} />
        </Column>
        <Column>
          <FormInput label="Address" value={[address.line_one, address.line_two].filter(x => x).join(', ')} />
          <FormInput label="City, State, Zip" value={[address.city, address.state_province, address.postal_code].filter(x => x).join(', ')} />
          <FormInput label="Country" value={address.country} />
        </Column>
      </Columns>
    </Subsection>
  )
}

const EventLogs =
  pureRenderProps({
    logs: OrderModel.attributes.logs
  },
    ({ logs }) => {
      const grouped = logs.groupBy(x => asDate(x.timestamp));

      return (
        <InlineTable noBorders>
          {Object.keys(grouped).map(date =>
            <Fragment key={date}>
              <TableRow className="group">
                <TableCell colSpan={4}>
                  <FormLabel>{date}</FormLabel>
                </TableCell>
              </TableRow>

              {grouped[date].map(event =>
                <TableRow key={event.cid}>
                  <TableCell className="fit-width">
                    {
                      event.event === 'File Uploaded' ? <AttachmentIcon/> :
                        event.event === 'Commented FIX ME' ? <MessageIcon /> :
                          <DoneIcon fontSize="small" />
                    }

                  </TableCell>
                  <TableCell>
                    {event.event}
                  </TableCell>

                  <TableCell className="fit-width">
                    <FormValue>{event.author}</FormValue>
                  </TableCell>

                  <TableCell className="fit-width">
                    <FormLabel>{asTime(event.timestamp)}</FormLabel>
                  </TableCell>
                </TableRow>
              )}
            </Fragment>
          )}
        </InlineTable>
      )
    })
